var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHydraLauncher(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 60,
    viewBox: "0 0 120 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M118.723 17.8456C118.723 17.8456 117.733 15.7096 117.524 15.5266C117.316 15.3436 115.733 14.8381 115.733 14.8381H107.68L106.778 15.2326H98.4156L95.8821 16.3306H77.6376V13.1206C77.6376 13.1206 75.4416 12.5296 75.2211 12.5296C75.0006 12.5296 70.2321 12.6091 69.8676 12.6136C69.5031 12.6196 69.0951 11.5996 69.0951 11.5996H67.8681L67.5021 9.44559L61.7376 6.34209C61.7376 6.34209 58.9146 6.27909 58.7466 6.34209C58.5771 6.40509 56.3526 6.34209 56.3526 6.34209L49.2726 8.43009L45.3516 9.30609L41.0646 9.31959L39.4596 10.2766C39.4596 10.2766 39.4596 13.2046 39.2016 13.4356C38.9436 13.6666 33.5481 13.2946 33.5481 13.2946L31.1556 13.8391H6.00963L3.81363 14.9791L3.48212 15.8626L1.70312 16.5841V20.5426C1.70312 20.8396 1.70312 22.1596 2.09762 22.1596C2.49212 22.1596 3.81513 22.8346 3.81513 22.8346V29.0896L5.08263 29.1271V31.8721C5.08263 32.1256 7.36263 33.1816 7.36263 33.1816L7.95362 32.9701L9.52712 32.9371L8.84013 34.6171L8.88213 36.7291L7.95362 37.7431L9.05162 40.0231L10.6011 40.8661L12.6006 40.6996L13.4451 40.8691L14.2896 40.7431L16.1901 39.3076L19.5681 39.3496L25.5801 40.6216L28.7901 41.0296L31.1556 40.8151L33.8451 40.1116L37.2411 38.1706L38.1666 37.4011L38.7861 37.6201L40.6161 36.8386C40.6161 36.8386 41.8551 36.7936 42.0246 36.7981C42.1941 36.8011 43.3596 37.1896 43.3596 37.1896L43.7151 36.6526L44.3901 35.9866L45.8841 36.3121H49.1781L49.8111 35.4676L53.0631 35.0881L62.9031 35.1301C62.9031 35.1301 64.7886 35.6581 64.9191 35.8066C65.0496 35.9536 66.0051 37.9066 66.1521 38.1736C66.2991 38.4406 67.2126 39.5086 67.2126 39.5086L68.0571 39.4816L69.1011 39.5356H73.6056C73.6056 39.5356 74.4621 39.7381 75.2271 40.6921C75.9921 41.6461 75.2796 43.0291 75.2796 43.0291L76.2651 44.1271C76.2651 44.1271 77.6121 47.5066 77.8131 48.5191C78.0141 49.5316 77.0256 50.1736 77.0256 50.1736C77.0256 50.1736 76.5456 52.4896 76.4676 53.0236C76.3896 53.5576 77.0526 54.2626 77.0526 54.2626H81.5016C81.6711 54.2626 83.5356 54.1921 84.2376 54.0346C84.9396 53.8771 85.8486 53.2291 85.8486 53.2291L104.195 42.4951L112.867 42.0031L114.725 39.0046V36.3586L115.292 34.8811V33.0811L114.725 31.9681C114.725 31.9681 114.869 30.4486 114.895 29.0956C114.919 27.7426 115.75 26.8996 115.75 26.8996L117.692 24.6106L118.789 23.4076V22.1686L118.729 17.8561L118.723 17.8456ZM72.7806 36.4966C72.7011 37.4401 72.1641 38.0971 72.1101 38.1601C72.1206 38.1631 72.1041 38.1661 72.1041 38.1661C72.1041 38.1661 72.1071 38.1631 72.1101 38.1601C72.0786 38.1496 71.8101 38.1331 70.1616 38.1646C67.9656 38.2066 68.3451 37.5736 68.3451 37.5736L67.2051 34.8286C67.2471 34.1101 68.1771 34.1956 68.1771 34.1956C68.1771 34.1956 70.9641 34.1536 71.9781 34.1956C72.9921 34.2376 72.8646 35.5051 72.7806 36.4981V36.4966ZM82.8471 53.0161H78.8496C78.4446 53.0161 78.1176 52.6876 78.1176 52.2841C78.1176 51.8806 78.4461 51.5521 78.8496 51.5521H82.8471C83.2521 51.5521 83.5791 51.8791 83.5791 52.2841C83.5791 52.6891 83.2506 53.0161 82.8471 53.0161ZM96.3051 40.1491C95.2071 40.8256 87.4356 45.3016 87.4356 45.3016C87.4356 45.3016 85.6611 46.3156 84.3951 44.3731C83.1276 42.4306 82.6206 41.0791 82.6206 41.0791C82.6206 41.0791 82.0296 40.0651 81.4386 39.8116C80.8476 39.5581 79.8336 38.3761 80.2566 36.3481C80.6796 34.3216 82.1151 33.7291 85.6626 33.7291H94.8696C94.8696 33.7291 97.9956 33.3916 98.5866 36.0091C99.1776 38.6281 97.4046 39.4726 96.3066 40.1476L96.3051 40.1491Z",
    fill: "#FAFAFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.71191 18.441V32.463",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.90804 21.2565L22.705 20.637C22.705 20.637 25.915 20.355 26.365 20.187C26.815 20.0175 27.7165 19.905 28.3915 19.905H30.193C30.193 19.905 31.15 19.848 31.15 20.58V24.072C31.15 24.072 31.0375 24.9165 29.911 24.9165H28.5025C28.5025 24.9165 27.799 24.8745 27.235 24.7335C26.671 24.5925 25.531 24.297 25.531 24.297C25.531 24.297 24.898 24.114 23.4055 24.1005C21.913 24.087 9.97454 24.0585 9.97454 24.0585H8.58104C8.58104 24.0585 7.54604 24.024 7.54604 23.397V21.9675C7.54604 21.9675 7.41254 21.2565 8.90504 21.2565H8.90804Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.887 21.168V24.0615",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4678 22.4115H21.4018",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0559 20.667V24.0615",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7284 20.541C23.7194 20.541 23.7284 24.06 23.7284 24.06",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0537 21.189H25.5762V23.4135H30.0537V21.189Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8.90804 30.717L22.705 31.3365C22.705 31.3365 25.915 31.6185 26.365 31.7865C26.815 31.956 27.7165 32.0685 28.3915 32.0685H30.193C30.193 32.0685 31.15 32.1255 31.15 31.3935V27.9015C31.15 27.9015 31.0375 27.057 29.911 27.057H28.5025C28.5025 27.057 27.799 27.099 27.235 27.24C26.671 27.381 25.531 27.6765 25.531 27.6765C25.531 27.6765 24.898 27.8595 23.4055 27.873C21.913 27.8865 9.97454 27.915 9.97454 27.915H8.58104C8.58104 27.915 7.54604 27.9495 7.54604 28.5765V30.006C7.54604 30.006 7.41254 30.717 8.90504 30.717H8.90804Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M10.887 30.807V27.9135",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4678 29.5635H21.4018",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0559 31.308V27.9135",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7284 31.434C23.7194 31.434 23.7284 27.915 23.7284 27.915",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0537 28.5615H25.5762V30.786H30.0537V28.5615Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5445 20.412V24.213C33.5445 24.213 33.516 25.086 34.305 25.1415C35.094 25.197 35.3475 25.113 35.628 24.9165C35.91 24.72 36.078 24.6675 36.078 24.06V22.101C36.078 22.101 36.162 21.6225 35.712 21.312C35.262 21.0015 34.5855 20.5395 34.5855 20.5395C34.5855 20.5395 33.543 19.791 33.543 20.4105L33.5445 20.412Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1638 21.9885C34.1638 21.9885 34.9798 21.876 35.1778 21.9885C35.3758 22.101 35.3188 22.974 35.3188 22.974C35.3188 22.974 35.2963 23.397 34.8148 23.2275C34.3333 23.058 33.5728 22.383 34.1638 21.9885V21.9885Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5445 31.5615V27.7605C33.5445 27.7605 33.516 26.8875 34.305 26.832C35.094 26.7765 35.3475 26.8605 35.628 27.057C35.9085 27.2535 36.078 27.306 36.078 27.9135V29.8725C36.078 29.8725 36.162 30.351 35.712 30.6615C35.262 30.972 34.5855 31.434 34.5855 31.434C34.5855 31.434 33.543 32.1825 33.543 31.563L33.5445 31.5615Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1638 29.985C34.1638 29.985 34.9798 30.0975 35.1778 29.985C35.3758 29.8725 35.3188 28.9995 35.3188 28.9995C35.3188 28.9995 35.2963 28.5765 34.8148 28.746C34.3333 28.9155 33.5728 29.5905 34.1638 29.985V29.985Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4465 18.8355V31.956",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M8.23242 24.918V26.8155",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7848 26.8575L21.8923 26.7135C21.6103 26.6685 21.4033 26.424 21.4033 26.139V25.911C21.4033 25.617 21.6223 25.3695 21.9148 25.3335L22.8028 25.224C23.0803 25.1895 23.3248 25.4055 23.3248 25.686V26.3985C23.3248 26.685 23.0683 26.9025 22.7863 26.8575H22.7848Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4729 13.458L36.4589 14.838H35.5304L32.1929 15.9915H4.23438",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4589 14.838C36.4589 14.838 36.0794 15.4005 37.1774 15.444C38.2754 15.486 39.4574 15.444 39.4574 15.444C39.4574 15.444 40.0484 15.4905 41.0204 15.15C41.9924 14.8095 43.3004 14.472 43.3004 14.472L45.7919 13.458",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7185 15.4005H45.328L41.0935 17.4705H37.9795V21.939",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9229 23.7211H49.0039C49.0039 23.7211 50.3554 23.9326 52.7209 23.0881C55.0864 22.2436 59.2248 20.6671 59.2248 20.6671V16.3306",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3496 9.30603V13.458",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7188 13.458V12.36L53.4373 11.5995H63.4888L64.4173 11.853H67.5013",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7188 14.46L53.7748 13.7955H62.0098H63.5308L64.2058 13.458H68.1343L69.8653 12.6135",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M65.685 16.3305L63.5205 14.838L62.01 13.7955",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M77.0192 20.412L75.2207 21.567V25.0305",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M80.1555 16.4985V17.892V18.399L78.918 19.1925",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M71.0205 23.7435V21.939H81.7755L85.1535 22.842H96.867C96.867 22.842 97.9365 23.1915 98.049 23.745C98.1615 24.2985 98.049 25.1325 98.049 25.1325",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M105.427 16.4985V30H103.906V29.253V20.037L104.244 18.948V16.4985H105.427Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M81.1576 39.642C81.1576 39.642 79.9171 40.0665 79.0156 39.108C78.1141 38.151 76.3126 35.3625 78.7906 33.7155C81.2686 32.0685 87.3496 28.8435 87.3496 28.8435H97.0921C97.0921 28.8435 95.9101 31.3365 99.0631 32.5185C102.216 33.7005 102.441 38.826 99.5701 40.5705C96.6976 42.3165 88.5331 47.328 88.5331 47.328C88.5331 47.328 85.2676 49.017 83.5216 46.4835C81.7756 43.95 84.7201 42.798 81.1576 39.6405V39.642Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M76.2571 43.2195C76.2571 43.2195 78.1996 43.023 78.2836 43.023C78.3676 43.023 79.6636 42.714 80.3956 44.6565C81.1276 46.599 81.5221 48.0915 80.3956 48.627C79.2691 49.1625 77.5351 49.6965 77.5351 49.6965",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0322 39.4741H77.1012C77.1012 39.4741 78.9027 39.3616 79.0437 40.6846C79.1847 42.0076 78.3957 42.2326 77.3547 42.3181C76.3122 42.4021 75.4542 42.4666 75.4542 42.4666",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M112.564 36.405V38.7555C112.564 38.7555 112.606 40.065 110.79 40.065C108.973 40.065 109.354 40.065 109.354 40.065C109.354 40.065 108.552 39.939 107.454 40.572C106.356 41.205 103.906 42.651 103.906 42.651",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M109.566 33.942H103.99C103.477 33.942 103.062 34.3577 103.062 34.8705V34.872C103.062 35.3848 103.477 35.8005 103.99 35.8005H109.566C110.078 35.8005 110.494 35.3848 110.494 34.872V34.8705C110.494 34.3577 110.078 33.942 109.566 33.942Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M90.7564 19.1174H88.6744C88.3165 19.1174 88.0264 19.4072 88.0264 19.7647C88.0264 20.1221 88.3165 20.4119 88.6744 20.4119H90.7564C91.1142 20.4119 91.4044 20.1221 91.4044 19.7647C91.4044 19.4072 91.1142 19.1174 90.7564 19.1174Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M77.2157 20.412H76.4957C76.1387 20.412 75.8477 20.1225 75.8477 19.764C75.8477 19.407 76.1372 19.116 76.4957 19.116H78.5792C78.9362 19.116 79.2272 19.4055 79.2272 19.764C79.2272 20.121 78.9377 20.412 78.5792 20.412H77.2157Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M102.216 19.1174H100.134C99.7764 19.1174 99.4863 19.4072 99.4863 19.7647C99.4863 20.1221 99.7764 20.4119 100.134 20.4119H102.216C102.574 20.4119 102.864 20.1221 102.864 19.7647C102.864 19.4072 102.574 19.1174 102.216 19.1174Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6977 15.0631C70.0308 15.0631 70.3007 14.7931 70.3007 14.4601C70.3007 14.127 70.0308 13.8571 69.6977 13.8571C69.3647 13.8571 69.0947 14.127 69.0947 14.4601C69.0947 14.7931 69.3647 15.0631 69.6977 15.0631Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7001 9.09301V10.641C63.7001 10.641 63.6161 11.0355 64.2356 11.0355H66.0941C66.0941 11.0355 66.4466 11.0355 66.4466 10.7265C66.4466 10.4175 66.5036 10.2765 66.1796 10.065C65.8556 9.85351 64.3781 8.99551 64.3781 8.99551C64.3781 8.99551 63.7031 8.57251 63.7031 9.09451L63.7001 9.09301Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M57.513 6.46802V9.44552H56.6895V11.5995",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5127 9.44556H61.7352V11.4946",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9121 9.44554V6.34204",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4893 23.535V32.7705",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6975 23.7435V31.956",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M75.2207 26.2545V28.8435H77.5367L78.2702 28.4505H79.5377V26.2545H75.2207Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7505 27.8505H70.71V29.253H73.7505V27.8505Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7505 25.1325H70.71V26.535H73.7505V25.1325Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7505 30.5535H70.71V31.956H73.7505V30.5535Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9874 40.6681C12.9874 40.6681 12.5689 40.5151 13.5274 38.7691C14.4844 37.0231 15.7234 35.4601 15.7234 35.4601C15.7234 35.4601 15.9139 34.5946 18.4369 34.5946H29.0134C29.0134 34.5946 29.9149 34.7431 30.7879 34.2916L31.6609 33.8416C31.6609 33.8416 32.1679 33.7006 33.1534 33.7006H37.2649C37.2649 33.7006 38.1664 33.6721 38.1664 34.4326V37.3951",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3264 38.7705C35.3264 38.7705 35.6009 38.1795 35.6009 37.869C35.6009 37.5585 35.0384 36.9405 35.0384 36.9405C35.0384 36.9405 34.4744 35.9835 33.5459 36.4905C32.6174 36.9975 31.4339 37.557 31.4339 37.557C31.4339 37.557 30.8144 37.6725 30.3914 37.842C29.9684 38.0115 29.7719 38.799 30.0539 39.1935C30.3359 39.588 32.4479 40.32 32.4479 40.32",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7574 40.668C30.7574 40.668 29.4899 40.149 29.3219 39.981C29.1539 39.813 28.8434 39.2775 28.9559 38.7135C29.0684 38.1495 29.1254 38.0385 28.5059 37.671C27.8864 37.3035 27.2669 36.9675 27.2669 36.9675C27.2669 36.9675 27.0869 36.6585 25.5299 36.6585H19.3499C19.3499 36.6585 18.3134 36.546 17.9759 37.053C17.6384 37.56 17.5814 37.476 17.3984 37.56C17.2154 37.644 17.0324 37.827 16.9199 38.208C16.8074 38.589 16.8074 39.3165 16.8074 39.3165",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M15.862 39.1365C15.862 39.1365 15.6655 38.616 15.595 38.418C15.5245 38.22 15.778 37.812 16.018 37.4745C16.258 37.137 16.9045 36.3405 16.9045 36.3405C16.9045 36.3405 17.3545 35.7705 19.171 35.7705H26.8435C26.8435 35.7705 27.6745 35.658 28.3075 36.1785C28.9405 36.699 29.575 37.0575 30.5875 36.6465C31.6015 36.2355 32.938 35.6295 32.938 35.6295C32.938 35.6295 33.769 35.151 33.8395 34.8405L33.91 34.5315H35.7685C35.7685 34.5315 36.6415 34.518 36.6415 35.3205V38.4885",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9895 9.03448C47.9895 9.03448 47.9895 9.76349 49.2 10.47C50.4105 11.178 52.719 12.6135 52.719 12.6135",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M6.00896 13.8376H28.6875C28.6875 13.8376 31.3485 13.9636 32.7 13.4581C34.0515 12.9511 39.4575 13.4581 39.4575 13.4581V9.99456L41.0625 9.31956H44.2725C44.2725 9.31956 45.9615 9.40356 47.3985 8.98206C48.834 8.55906 55.4235 6.61656 55.4235 6.61656C55.4235 6.61656 56.352 6.27906 57.873 6.27906H60.7455C60.7455 6.27906 61.4205 6.02556 63.111 6.95406C64.8 7.88256 67.0815 9.06606 67.0815 9.06606C67.0815 9.06606 67.5045 9.17556 67.5045 10.0501V11.9386L68.265 12.9526V11.6011H69.447L69.87 12.6151L75.4455 12.5311L77.6415 13.1221V16.3321H95.886L98.4195 15.2341H107.119L107.682 14.8396H114.834C114.834 14.8396 119.001 14.2201 118.776 19.1191L118.785 22.1596C118.785 22.1596 119.001 22.9486 118.156 24.0181C117.312 25.0876 116.016 26.6086 116.016 26.6086C116.016 26.6086 114.946 27.5101 114.889 29.0866C114.832 30.6631 114.889 32.1271 114.889 32.1271L115.339 33.1966C115.339 33.1966 115.677 36.0691 114.72 36.3496V39.4471L112.749 42.1501L104.19 42.4876L85.6635 53.3281C85.6635 53.3281 84.5655 54.2566 82.623 54.2566H77.0475C77.0475 54.2566 76.203 53.4961 76.5405 52.4821C76.878 51.4681 77.0475 49.9486 77.0475 49.9486C77.0475 49.9486 77.808 49.5256 77.808 48.5131C77.808 47.5006 76.203 43.6981 76.203 43.6981L75.2745 43.0231C75.2745 43.0231 75.6975 42.2206 75.444 41.1226C75.1905 40.0246 74.0505 39.4756 74.0505 39.4756H68.0535C68.0535 39.4756 67.167 39.9826 66.4065 38.6311C65.646 37.2796 65.055 36.0976 65.055 36.0976C65.055 36.0976 64.929 35.1256 62.901 35.1256C60.873 35.1256 53.061 35.0836 53.061 35.0836L49.809 35.4631L49.176 36.3076H45.882L44.9535 36.0121L44.151 35.9701C44.151 35.9701 43.9815 37.2796 43.56 37.2376C43.137 37.1956 42.969 36.8146 42.969 36.8146L40.9845 36.7726C40.9845 36.7726 39.126 37.6591 38.7885 37.6171C38.451 37.5751 38.028 37.3216 38.028 37.3216L37.6905 37.9126L33.8475 40.1086C33.8475 40.1086 31.0185 41.0371 29.286 41.0371C27.5535 41.0371 25.908 40.6996 24.7665 40.4461C23.6265 40.1926 20.5005 39.3481 19.572 39.3481C18.6435 39.3481 16.194 39.3061 16.194 39.3061L14.2935 40.7416L13.449 40.8676C13.449 40.8676 12.984 40.5301 12.6045 40.6981C12.225 40.8676 10.3665 40.8676 10.3665 40.8676C10.3665 40.8676 9.60596 40.5301 9.05696 40.0231C8.50796 39.5161 8.17046 39.0511 8.17046 39.0511C8.17046 39.0511 7.87496 38.0371 7.95896 37.7416C8.04296 37.4461 8.80346 36.9811 8.88746 36.7276C8.97146 36.4741 8.84546 34.6156 8.84546 34.6156C8.84546 34.6156 8.71946 34.1926 9.18296 33.8131C9.64796 33.4336 9.98546 32.9266 9.98546 32.9266L7.95896 32.9686L7.36796 33.1801C7.36796 33.1801 6.73496 33.0676 6.26996 32.7226C5.80496 32.3776 5.08796 31.8706 5.08796 31.8706V29.1256H3.94796V22.8331L2.59646 22.1581H1.70996V16.3291H2.55446L3.82196 15.6961V14.9776L6.01796 13.8376H6.00896Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M9.97754 32.9282H25.069L25.576 33.3647H29.968L32.5015 31.9562H39.0895L40.216 32.4062H42.187C42.187 32.4062 43.708 32.2367 43.708 33.3632V37.2347",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M3.81128 15.6961V20.7511V22.8346",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M3.81128 20.7511L6.71078 18.4426H11.8348L12.9043 17.8231H25.4623L26.8423 18.8371H35.0353L41.8768 25.6786H53.5048L60.3523 23.8486C60.3523 23.8486 61.8958 23.4541 63.2473 23.4541H68.3158C68.3158 23.4541 70.1173 23.2846 71.4688 24.1861L72.8203 25.0306H97.8793L98.9488 25.6786H99.8503L101.934 27.9586V29.2531L103.905 31.9561H112.858V28.5211C112.858 28.5211 113.14 26.7196 113.928 25.5931L114.717 24.4666C114.717 24.4666 115.336 23.6776 115.279 21.9886C115.222 20.2996 115.279 14.8366 115.279 14.8366",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6196 41.0791C82.6196 41.0791 82.0286 40.0652 81.4376 39.8117C80.8466 39.5582 79.8326 38.3762 80.2556 36.3482C80.6786 34.3217 82.1142 33.7292 85.6617 33.7292H94.8687C94.8687 33.7292 97.9946 33.3917 98.5856 36.0092C99.1766 38.6282 97.4036 39.4726 96.3056 40.1477C95.2076 40.8227 87.4361 45.3002 87.4361 45.3002C87.4361 45.3002 85.6617 46.3142 84.3957 44.3717C83.1282 42.4292 82.6212 41.0777 82.6212 41.0777L82.6196 41.0791Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M67.2056 34.8286L68.3456 37.5736C68.3456 37.5736 67.9661 38.2066 70.1621 38.1646C72.3581 38.1226 72.1046 38.1661 72.1046 38.1661C72.1046 38.1661 72.6956 37.4911 72.7796 36.4966C72.8636 35.5021 72.9911 34.2361 71.9771 34.1941C70.9631 34.1521 68.1761 34.1941 68.1761 34.1941C68.1761 34.1941 67.2476 34.1101 67.2041 34.8271L67.2056 34.8286Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9775 34.1956L73.752 34.1761C73.752 34.1761 75.4125 34.0876 75.2025 35.6086C74.991 37.1296 74.565 37.4491 73.9425 37.7881C73.3215 38.1256 72.105 38.1676 72.105 38.1676",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M39.457 13.4581H52.7185V15.4006L55.5055 16.3306",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6369 16.3306H55.5059",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8389 31.9562V30.9002L37.5994 30.5207V29.2532H38.6554L39.0784 30.6047H40.3039V31.3652C40.3039 31.3652 41.6554 31.5347 41.6554 31.3652V29.7602H43.7104V30.8582H43.0069V32.4632H40.2199L39.0934 31.9562H36.8404H36.8389Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8389 30.9001V20.6371",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4998 32.7706H46.7218H49.5943V35.4616",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7217 32.7706V30.0001H48.5802C48.5802 30.0001 49.6782 30.0976 49.8897 28.9996H56.3517V24.9166",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5947 32.7706H67.4177V31.9561H74.4002C74.4002 31.9561 75.2447 32.0686 75.9767 31.7311C76.7087 31.3936 77.2157 31.1686 78.2297 31.1686C79.2437 31.1686 79.7507 30.8596 79.7507 30.8596L85.2692 27.9031C85.2692 27.9031 85.5512 27.1141 88.5917 27.1141H97.1507L97.9397 27.5086H99.4037L100.812 28.8451V31.0006L101.544 31.9576H103.91",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M114.719 36.3482L112.86 36.4052V31.9562",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M112.86 36.4051C112.86 36.4051 112.353 36.1801 111.283 36.7996C110.214 37.4191 84.0283 52.3981 84.0283 52.3981",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M82.8465 51.5536H78.8475C78.4432 51.5536 78.1155 51.8813 78.1155 52.2856C78.1155 52.6899 78.4432 53.0176 78.8475 53.0176H82.8465C83.2507 53.0176 83.5785 52.6899 83.5785 52.2856C83.5785 51.8813 83.2507 51.5536 82.8465 51.5536Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHydraLauncher);
export default __webpack_public_path__ + "static/media/Hydra Launcher.b39ce0d80051b35a56418e0f0ce8f4d6.svg";
export { ForwardRef as ReactComponent };